import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SzBrandBlockComponent, SzIconComponent } from '@ui';
import { NAVIGATION_TOKEN, NavigationProvider } from '@core';

@Component({
  selector: 'app-legal-terms-page',
  templateUrl: './legal-terms.page.html',
  styleUrls: ['./legal.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzBrandBlockComponent, SzIconComponent]
})
export class LegalTermsPage {
  private readonly navigation: NavigationProvider = inject(NAVIGATION_TOKEN);

  goBack(): void {
    this.navigation.back();
  }
}
